
  import { Component, Vue } from 'vue-property-decorator'

  import stories from '@/stories/index'

  @Component({ name: 'StoryViewerRoute' })
  export default class extends Vue {
    get stories() {
      return stories
    }
  }
